import { Activity, ImportResponse, ProjectActivity } from "../types/ActivityTypes";
import axios from 'axios';
import apiClient from "./apiClient";

export const getActivities = async (): Promise<Activity[]> => {
  const response = await apiClient.get(`/Activities`);
  return await response.data;
};

export const createUpdateActivity = async (activity: Activity): Promise<Activity> => { 
    const response = await apiClient.post(`/Activities`, activity);
      return await response.data;
};

export const deleteActivity = async (activityId: string): Promise<void> => {
  await apiClient.delete(`/Activities/${activityId}`);
};

export const downloadFormatActivities = async () => {
  try {
    const response = await apiClient.get(`/Activities/download-format`, { responseType: 'blob' });
    const data = response.data;

    const blob = await data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Actividades-formato.xlsx';
    a.click();
  } catch (error) {
    console.error('Error al descargar el formato:', error);
  }
};

export const importActivities = async (file: File): Promise<ImportResponse> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ImportResponse>('/Activities/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    console.error('Error al importar actividades:', error);

    if (error.response) {
      return {
        message: error.response.data || 'Error en la importación',
      };
    } else {
      return {
        message: 'Error de conexión con el servidor',
      };
    }
  }
};

export const exportActivities = async () => {
  try {
    const response = await apiClient.get(`/Activities/export`, { responseType: 'blob' });
    const data = response.data;

    const blob = await data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Actividades.xlsx';
    a.click();
  } catch (error) {
    console.error('Error al exportar actividades:', error);
  }
};

export const updateProjectActivitiesOrder = async (activities: ProjectActivity[]) : Promise<ProjectActivity[]> => {
  const response = await apiClient.patch(`/projectsActivities`, activities)
  return await response.data;
}


export const getProjectActivities = async (activityId: number): Promise<ProjectActivity[]> => {
  const response = await apiClient.get(`/projectsActivities/${activityId}`);
  const activities: ProjectActivity[] = await response.data;
  return activities.sort((a, b) => {
    const orderA = a.order === undefined ? Infinity : a.order;
    const orderB = b.order === undefined ? Infinity : b.order;
    return orderA - orderB; // Ascending order
});
};

export const createUpdateProjectActivity = async (activity: ProjectActivity): Promise<ProjectActivity> => { 
    const response = await apiClient.post(`/projectsActivities`, activity);
      return await response.data;
};

export const deleteprojectActivity = async (activityId: number): Promise<void> => {
  await apiClient.delete(`/projectsActivities/${activityId}`);
};



